import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, TextField, Grid, Menu, MenuItem, Button } from '@mui/material';
import { Bar } from 'react-chartjs-2';
import axios from 'axios';
import { TodayLabels, WeeklyLabels, MonthlyLabels, backgroundColor, borderColor } from '../../../Variables/Variables';
import { tax_graph } from '../../../Services/APIService';

function TaxChart() {
  const [currentMode, setCurrentMode] = useState('Today');
  const [orderType, setOrderType] = useState('Online sale');
  const [weekNumber, setWeekNumber] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [data, setData] = useState([]);
  const textFieldFromRef = useRef();
  const textFieldToRef = useRef();
  const textFieldWeekRef = useRef();

    const [selectedDate, setSelectedDate] = useState("");
        const [weekRange, setWeekRange] = useState(""); // Stores "YYYY-MM-DD to YYYY-MM-DD"
        


  const handleDateChange2 = (e) => {
    const selected = new Date(e.target.value);
    if (isNaN(selected)) return;

    // Find Monday of the selected week
    const dayOfWeek = selected.getDay();
    const monday = new Date(selected);
    monday.setDate(selected.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1)); // Adjust for Sunday

    // Find Sunday of the selected week
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    // Format to YYYY-MM-DD
    const formattedMonday = monday.toISOString().split("T")[0];
    const formattedSunday = sunday.toISOString().split("T")[0];

    setSelectedDate(e.target.value);
    setWeekRange(`${formattedMonday} to ${formattedSunday}`);

    // Convert to "YYYYWW" format (like "202509")
    const weekYear = monday.getFullYear();
    const weekNo = Math.ceil(
      ((monday - new Date(weekYear, 0, 1)) / 86400000 + new Date(weekYear, 0, 1).getDay() + 1) / 7
    );
    setWeekNumber(`${weekYear}${weekNo < 10 ? "0" : ""}${weekNo}`);
  };

  const handleFetchData = () => {
    if (weekNumber) {
      fetchChartData({ checkBox: 'Weekly', orderType, weekNumber: weekNumber });
    }
  };


  // API call handler
  const fetchChartData = async (params) => {
    const formData = new FormData();
    formData.append('checkBox', params.checkBox);
    formData.append('orderType', params.orderType);
    if (params.weekNumber) formData.append('weekNumber', params.weekNumber);
    if (params.fromDate) formData.append('fromDate', params.fromDate);
    if (params.toDate) formData.append('toDate', params.toDate);

    try {
      const response = await axios.post(tax_graph, formData);
      setData(response.data?.data || []);
    } catch (error) {
      console.error('Error fetching chart data:', error);
    }
  };

  // Handle mode change (Today, Weekly, Monthly)
  const handleModeChange = (mode) => {
    setCurrentMode(mode);
    if (mode === 'Today') {
      fetchChartData({ checkBox: 'Today', orderType });
      setSelectedDate("");
      setWeekRange("");
      setWeekNumber("");
    } else if (mode === 'Weekly') {
      setWeekNumber('');
    } else if (mode === 'Monthly') {
      setFromDate('');
      setToDate('');
      setSelectedDate("");
      setWeekRange("");
      setWeekNumber("");
    }
  };

  // Handle order type change
  const handleOrderTypeChange = (event) => {
    setOrderType(event.target.value);
    fetchChartData({ checkBox: currentMode, orderType: event.target.value });
  };

  // Fetch data when weekNumber is updated
  const handleWeekChange = (event) => {
    const fullWeekValue = event.target.value;
    const week = fullWeekValue.replace('-W', '');
    setWeekNumber(week);
    fetchChartData({ checkBox: 'Weekly', orderType, weekNumber: week });
  };

  // Fetch data when date range changes
  const handleDateChange = () => {
    fetchChartData({
      checkBox: 'Monthly',
      orderType,
      fromDate: fromDate || textFieldFromRef.current.value,
      toDate: toDate || textFieldToRef.current.value,
    });
  };

  // Labels and chart data
  const labels = ['GST', 'PST'];


  const chartData = {
    labels,
    datasets: [
      {
        label: 'GST,PST',
        backgroundColor: backgroundColor[5],
        borderColor: borderColor[5],
        borderWidth: 1,
        data: [data.gst, data.pst],
      },
    ],
  };



  return (
    <Box>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={1}>
          <Typography variant="h6" sx={{ fontWeight: '', color: 'primary.main' }}>
            Tax Report
          </Typography>
        </Grid>
        <Grid item xs={12} sm={11} display="flex" flexWrap={"wrap"} justifyContent="end">
          <Button onClick={() => handleModeChange('Today')} color={currentMode === 'Today' ? 'success' : 'inherit'}>
            Today
          </Button>
          <Button onClick={() => handleModeChange('Weekly')} color={currentMode === 'Weekly' ? 'success' : 'inherit'}>
            Weekly
          </Button>
          <Button onClick={() => handleModeChange('Monthly')} color={currentMode === 'Monthly' ? 'success' : 'inherit'}>
            Monthly
          </Button>
          <TextField
            select
            value={orderType}
            onChange={handleOrderTypeChange}
            label="Order Type"
            size="small"
            sx={{ ml: 2 }}
          >
            <MenuItem value="Online sale">Online Sale</MenuItem>
            <MenuItem value="Channel sale">Channel Sale</MenuItem>
            <MenuItem value="Whole sale">Whole Sale</MenuItem>
          </TextField>
        </Grid>
      </Grid>

      {/* {currentMode === 'Weekly' && (
  <TextField
    type="week"
   
    onChange={handleWeekChange}
    InputLabelProps={{ shrink: true }}
    label="Select Week"
    placeholder="YYYY-WW" // Add this line
    size="small"
    sx={{ mt: 2 }}
  />
)} */}
{
                        currentMode === 'Weekly' && <div sx={{display:"flex"}}>
                        <input  inputRef={textFieldWeekRef} type="date" value={selectedDate} onChange={handleDateChange2} required />
                              
                              {weekRange && <p sx={{mt:4}}>Selected Week: {weekRange}</p>}
                              <Button
                                onClick={handleFetchData}
                                variant="contained"
                                color="primary"
                                size="large"
                                sx={{
                                  m: 1,
                                  padding: "10px 20px",
                                  fontSize: "16px",
                                  fontWeight: "600",
                                  borderRadius: "8px",
                                  "&:hover": {
                                    backgroundColor: "#1e88e5",
                                  },
                                }}
                              >
                                Weekly
                              </Button>
                            </div>
                        }

      {currentMode === 'Monthly' && (
        <Box display="flex" gap={2} mt={2}>
          <TextField
            type="date"
            InputLabelProps={{ shrink: true }}
            inputRef={textFieldFromRef}
            onChange={(e) => setFromDate(e.target.value)}
            label="From Date"
            size="small"
          />
          <TextField
            type="date"
            InputLabelProps={{ shrink: true }}
            inputRef={textFieldToRef}
            onChange={(e) => setToDate(e.target.value)}
            label="To Date"
            size="small"
          />
          <Button onClick={handleDateChange} size={"small"} variant="contained" sx={{ display:"block" }}>
            Fetch 
          </Button>
        </Box>
      )}

      <Box mt={4}>
        <Bar
          data={chartData}
          options={{
            scales: {
              y: { beginAtZero: true },
              x: { ticks: { font: { size: 12, family: 'Jost, sans-serif' } } },
            },
            plugins: {
              legend: { display: false },
            },
          }}
        />
      </Box>
    </Box>
  );
}

export default TaxChart;
